module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "first-screen"
  }, [_c('div', {
    staticClass: "bg",
    style: (_vm.maskStyle)
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_vm._m(1), _vm._v(" "), _c('Form', {
    ref: "formItem",
    staticClass: "login-form",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.formRules
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "username"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    on: {
      "on-enter": function($event) {
        return _vm.handleSubmit('formItem')
      }
    },
    model: {
      value: (_vm.formItem.username),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "username", $$v)
      },
      expression: "formItem.username"
    }
  }, [_c('img', {
    attrs: {
      "slot": "prepend",
      "src": require("../../assets/login/acc.svg")
    },
    slot: "prepend"
  })])], 1), _vm._v(" "), _c('FormItem', [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    on: {
      "on-blur": _vm.checkpw,
      "on-enter": function($event) {
        return _vm.handleSubmit('formItem')
      }
    },
    model: {
      value: (_vm.formItem.password),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "password", $$v)
      },
      expression: "formItem.password"
    }
  }, [_c('img', {
    attrs: {
      "slot": "prepend",
      "src": require("../../assets/login/pwd.svg")
    },
    slot: "prepend"
  })])], 1), _vm._v(" "), (_vm.isshow) ? _c('FormItem', {
    attrs: {
      "prop": "verifyCode"
    }
  }, [_c('Input', {
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    on: {
      "on-enter": function($event) {
        return _vm.handleSubmit('formItem')
      }
    },
    model: {
      value: (_vm.formItem.imgcode),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "imgcode", $$v)
      },
      expression: "formItem.imgcode"
    }
  }, [_c('div', {
    staticClass: "imagecode",
    attrs: {
      "slot": "append"
    },
    on: {
      "click": function($event) {
        return _vm.getImgcode()
      }
    },
    slot: "append"
  }, [_c('img', {
    staticClass: "imgCode",
    attrs: {
      "src": _vm.formItem.imagelink
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    staticClass: "form-extra"
  }, [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('div', [_vm._v("温馨提示：如您已认证统一登录系统，请通过 "), _c('a', {
    staticStyle: {
      "color": "#337FE5"
    },
    attrs: {
      "href": _vm.$conf.serverRoot + 'front/sso/login?referer=' + (_vm.$route.query.referer || '')
    }
  }, [_vm._v("统一登录系统")]), _vm._v(" 进行登录！")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "25px",
      "position": "relative"
    }
  }, [_c('Button', {
    attrs: {
      "type": "ghost",
      "shape": "circle",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formItem')
      }
    }
  }, [_vm._v("登录")])], 1)], 1)], 1)])]), _vm._v(" "), _c('Modal', {
    staticClass: "forgetpm setpw",
    attrs: {
      "mask-closable": false
    },
    model: {
      value: (_vm.forgetPassModal),
      callback: function($$v) {
        _vm.forgetPassModal = $$v
      },
      expression: "forgetPassModal"
    }
  }, [_c('div', {
    staticClass: "setPass",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("设置密码")]), _vm._v(" "), _c('Form', {
    ref: "formInline",
    staticClass: "forgetpassword_con",
    attrs: {
      "label-width": 70,
      "label-position": "left",
      "model": _vm.formInline
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "username",
      "label": "用户名"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.formInline.username),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "username", $$v)
      },
      expression: "formInline.username"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "account",
      "label": "新密码"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "新密码"
    },
    on: {
      "on-blur": _vm.passVerifi
    },
    model: {
      value: (_vm.formInline.password),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "password", $$v)
      },
      expression: "formInline.password"
    }
  }), _vm._v(" "), (_vm.verifiPass) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("8-20位字母数字特殊字符至少包含两种")]) : _vm._e()], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "phone",
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.phone),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "phone", $$v)
      },
      expression: "formInline.phone"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "vertsed",
    attrs: {
      "prop": "veryfiycode",
      "label": "验证码"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "165px",
      "float": "left"
    },
    attrs: {
      "type": "text",
      "placeholder": "手机验证码"
    },
    model: {
      value: (_vm.formInline.veryfiycode),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "veryfiycode", $$v)
      },
      expression: "formInline.veryfiycode"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "sendCode",
    staticStyle: {
      "width": "90px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.formInline.phone, 'resetpassword')
      }
    }
  }, [_vm._v("发送验证码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "formBottom"
  }, [_c('Button', {
    staticStyle: {
      "font-size": "16px",
      "padding": "4px 20px"
    },
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.cancalForm
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "font-size": "16px",
      "padding": "4px 20px",
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('formInline')
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    staticClass: "forgetpm",
    attrs: {
      "mask-closable": false
    },
    model: {
      value: (_vm.ssomodal),
      callback: function($$v) {
        _vm.ssomodal = $$v
      },
      expression: "ssomodal"
    }
  }, [_c('div', {
    staticClass: "setPass",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("手机号验证")]), _vm._v(" "), _c('div', {
    staticClass: "setPass",
    staticStyle: {
      "text-align": "center",
      "font-size": "12px",
      "color": "#F95759"
    }
  }, [_vm._v("该手机号将作为今后此育人号登录的依据，请谨慎核对")]), _vm._v(" "), _c('Form', {
    ref: "ssobind",
    staticClass: "forgetpassword_con",
    attrs: {
      "label-width": 70,
      "label-position": "left",
      "model": _vm.ssobind,
      "rules": _vm.ssoRules
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.ssobind.mobile),
      callback: function($$v) {
        _vm.$set(_vm.ssobind, "mobile", $$v)
      },
      expression: "ssobind.mobile"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "vertsed",
    attrs: {
      "prop": "code",
      "label": "验证码"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "165px",
      "float": "left"
    },
    attrs: {
      "type": "text",
      "placeholder": "手机验证码"
    },
    model: {
      value: (_vm.ssobind.code),
      callback: function($$v) {
        _vm.$set(_vm.ssobind, "code", $$v)
      },
      expression: "ssobind.code"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "sendCode",
    staticStyle: {
      "width": "90px",
      "float": "left",
      "margin-left": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sendCode(_vm.ssobind.mobile, 'bindssoaccount')
      }
    }
  }, [_vm._v("发送验证码")])], 1), _vm._v(" "), _c('div', {
    staticClass: "formBottom"
  }, [_c('Button', {
    staticStyle: {
      "font-size": "16px",
      "padding": "4px 20px"
    },
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.cancalForm
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "font-size": "16px",
      "padding": "4px 20px",
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.ssosubmit
    }
  }, [_vm._v("提交")])], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "修改密码",
      "class-name": "vertical-center-modal",
      "width": "400",
      "closable": false
    },
    model: {
      value: (_vm.isModalVisible),
      callback: function($$v) {
        _vm.isModalVisible = $$v
      },
      expression: "isModalVisible"
    }
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-position": "left",
      "label-width": 100
    }
  }, [_c('div', {
    staticClass: "tips",
    staticStyle: {
      "margin": "5px 0px 10px",
      "text-align": "left",
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("根据安全需要，请将密码修改为\"8-20位字母、数字、特殊字符至少包含两种\"")]), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "新密码",
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "",
      "type": "password"
    },
    on: {
      "on-change": _vm.allowSubmit
    },
    model: {
      value: (_vm.formValidate.password),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "password", $$v)
      },
      expression: "formValidate.password"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "确认密码",
      "prop": "passwordConfirm"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "",
      "type": "password"
    },
    on: {
      "on-change": _vm.allowSubmit
    },
    model: {
      value: (_vm.formValidate.passwordConfirm),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "passwordConfirm", $$v)
      },
      expression: "formValidate.passwordConfirm"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("跳过")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "提示信息",
      "class-name": "vertical-center-modal",
      "width": "400",
      "closable": false
    },
    model: {
      value: (_vm.isModalCancel),
      callback: function($$v) {
        _vm.isModalCancel = $$v
      },
      expression: "isModalCancel"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('p', [_vm._v("请在9月30日前完成密码修改，否则您将无法登录，感谢您的理解和配合")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "温馨提示",
      "class-name": "vertical-center-modal",
      "width": "750",
      "closable": false
    },
    model: {
      value: (_vm.updatedialog),
      callback: function($$v) {
        _vm.updatedialog = $$v
      },
      expression: "updatedialog"
    }
  }, [_c('div', {
    staticClass: "updatecontent"
  }, [_c('p', [_vm._v("各位老师好，请大家注意：")]), _vm._v(" "), _c('p', [_vm._v("为进一步规范育人号内容建设，提升内容质量，高校思政网将进一步完善育人号审核流程。")]), _vm._v(" "), _c('p', [_vm._v("所有文章均需经过高校思政网编辑审核后方可正式对外发布，审核周期为2-3个工作日。")]), _vm._v(" "), _c('p', [_vm._v("审核未通过的文章，将被返修或退稿处理，育人号运营者需根据审核意见认真查改内容错误。")]), _vm._v(" "), _c('p', [_vm._v("新的审核流程于7月7日开始实行，请各单位（党组织）知悉，并认真做好稿件上传发布前的审核工作，严格落实责任，加强育人号内容把关，共同维护好我们培育创建的工作平台。")]), _vm._v(" "), _c('p', [_vm._v("谢谢~")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.updateCancel
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "提示信息",
      "class-name": "vertical-center-modal",
      "width": "400",
      "closable": false
    },
    model: {
      value: (_vm.isModalCancel),
      callback: function($$v) {
        _vm.isModalCancel = $$v
      },
      expression: "isModalCancel"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('p', [_vm._v("请在9月30日前完成密码修改，否则您将无法登录，感谢您的理解和配合")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("确定")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "mask-closable": false,
      "title": "温馨提示",
      "class-name": "vertical-center-modal"
    },
    model: {
      value: (_vm.gosso),
      callback: function($$v) {
        _vm.gosso = $$v
      },
      expression: "gosso"
    }
  }, [_c('div', {
    staticClass: "updatecontent",
    staticStyle: {
      "padding": "20px 0 40px",
      "text-align": "center"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.gossocontent))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "shape": "circle"
    },
    on: {
      "click": _vm.gossopage
    }
  }, [_vm._v("去登录")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/login/logo.png"),
      "alt": ""
    }
  }), _vm._v(" 育人号\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-box-text"
  }, [_c('span', {
    staticClass: "login-box-text-inner"
  }, [_vm._v("账号登录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45741d87"}!./src/view/login/index.html
// module id = 2089
// module chunks = 62